/**
 * Merges query parameters from a landing page URL into a base URL.
 * Landing page params take precedence over base URL params, except for protected keys.
 *
 * @param baseUrl - The base URL (can be relative or absolute)
 * @param landingParams - Query parameters from the landing page URL
 * @param protectedKeys - Optional set of parameter keys that should not be overridden (default: ['step'])
 * @returns The merged URL as a string (pathname + search + hash)
 * @throws Error if baseUrl is invalid or cannot be parsed
 */
export function mergeQueryParams(
  baseUrl: string,
  landingParams: URLSearchParams,
  protectedKeys: Set<string> = new Set(['step']),
): string {
  if (!baseUrl) {
    throw new Error('baseUrl is required');
  }

  try {
    const url = new URL(baseUrl, window.location.origin);

    landingParams.forEach((value, key) => {
      if (!protectedKeys.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    return url.pathname + url.search + url.hash;
  } catch (error) {
    throw new Error(`Failed to parse baseUrl: ${error}`, { cause: error });
  }
}
